// Import Vue 3 modules and plugins with TypeScript typings
import { createApp } from "vue";
import App from "@/app/index.vue";
import FlashApp from "@/flash-app/index.vue";
import "@/registerServiceWorker";
import router from "@/router";
import store from "@/stores/index";
import axios from "@/plugins/axios.plugin";
import { changeLocale, i18n, setLocalization } from "@/plugins/i18n.plugin";
import clickOutsideDirective from "@/plugins/outside.plugin";
import Toast from "@/plugins/toast.plugin";
import { components } from "@/services/utils/component.util";
import { plugins } from "@/services/utils/plugin.util";
import * as helper from "@/services/utils/helper.util";
import { schema } from "@/services/utils/schema.util";
import { getLocalizeService } from "@/services/apis/language.service";
import * as Enum from "@/constants/index";
import autoHtmlDirective from "@/plugins/directives.plugin";
// import "@vuepic/vue-datepicker/dist/main.css";
import { vMaska } from "maska/vue";

// Import Vue 3 typings
import { App as VueApp } from "vue";

// Create Vue 3 app instance
const app: VueApp<Element> = createApp(App);
const flashApp: VueApp<Element> = createApp(FlashApp);

// Set global properties
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$toast = Toast;
app.config.globalProperties.$changeLocalize = changeLocale;
app.config.globalProperties.$psm = helper.permissionQuery;
app.config.globalProperties.$helper = helper;
app.config.globalProperties.$schema = schema;
app.config.globalProperties.$moment = plugins?.moment;
app.config.globalProperties.$vueToast = plugins?.toast;
app.config.globalProperties.$enum = Enum;
app.config.globalProperties.$state = store.state;

// Register global directive
app.directive("outside", clickOutsideDirective);
app.directive("auto-html", autoHtmlDirective);
app.directive("maska", vMaska);

// Register global components
components.forEach((component) => {
  app.component(component?.name, component?.component);
});

mountFlashApp();

async function mountFlashApp() {
  flashApp.mount("#app");

  try {
    const response = await axios.get("https://api.ipify.org?format=json");
    localStorage.setItem("publicNetworkIP", response?.data?.ip);
  } catch (error) {
    console.error("Error:", error);
  } finally {
    getLocalizeService().then((data) => {
      if (data) {
        const newData = setLocalization(data?.data);
        localStorage.setItem("localizeValue", JSON.stringify(newData));
      }

      unmountFlashApp();
      mountApp();
    });
  }
}

function mountApp() {
  app.use(store);
  app.use(router);
  app.use(plugins?.vue3PhotoPreview);
  app.use(i18n);
  app.mount("#app");
}

function unmountFlashApp() {
  flashApp.unmount();
}

// Export global function and variable
const globals = app.config.globalProperties;

export { app as default, globals };
